<ng-template #templateRef>
  <div class="p-inputgroup">
    <p-multiSelect #multiselectRef
                   [options]="itemsSource"
                   [(ngModel)]="multiselectFilterValues"
                   [filter]="multiselectRef.options?.length > 5"
                   [showToggleAll]="false"
                   [showHeader]="multiselectRef.options?.length > 5"
                   [placeholder]="placeholder"
                   (onChange)="filter()"
                   dataKey="id"
                   optionLabel="name"
                   appendTo="body"></p-multiSelect>
    @if (isFilterApplied) {
      <button pButton
              type="button"
              icon="pi pi-times"
              (click)="cleanFilter()"></button>
    }
  </div>
</ng-template>